import React, { useEffect, useState, useCallback, useRef } from "react";
import {
    Modal, Button, Badge, Card, Row, Col,
    Container, Spinner, ButtonGroup,
    ToggleButton, Form, InputGroup, Collapse
} from 'react-bootstrap';
import { api } from '../../services/api.js';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import Foto from "../Components/Foto/index.jsx";
import PdfFullscreen from "../Components/Foto/pdf.jsx";
import ModalNovoChamado from "./ModalNovoChamado.jsx";
import { toast } from 'react-toastify';
import './chamado.css';
import Swal from 'sweetalert2';

// COMPONENTE DE AVATAR QUE BUSCA A FOTO VIA API /usuario/foto/:chapa E PERMITE AMPLIAR
const AvatarUsuarioApi = ({ chapa, nome, tamanho = '30px', onSelectFoto }) => {
    const [srcFoto, setSrcFoto] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!chapa) return;
        let isMounted = true;
        setLoading(true);

        api.get(`/usuario/foto/${chapa}`)
            .then(res => {
                if (isMounted && res.data) {
                    const base64 = res.data.foto || res.data.FOTO || res.data;
                    if (typeof base64 === 'string' && base64.trim() !== '') {
                        const url = base64.startsWith('data:')
                            ? base64
                            : `data:image/jpeg;base64,${base64}`;
                        setSrcFoto(url);
                    }
                }
            })
            .catch(() => {
                if (isMounted) setSrcFoto(null);
            })
            .finally(() => {
                if (isMounted) setLoading(false);
            });

        return () => { isMounted = false; };
    }, [chapa]);

    const handleClick = (e) => {
        if (srcFoto && onSelectFoto) {
            e.stopPropagation();
            onSelectFoto({
                foto: srcFoto,
                nome: nome || "Foto do Usuário",
                info01: `Chapa: ${chapa}`,
                info02: nome ? `Usuário: ${nome}` : ""
            });
        }
    };

    if (loading) {
        return (
            <div
                className="rounded-circle bg-light d-flex align-items-center justify-content-center flex-shrink-0"
                style={{ width: tamanho, height: tamanho, border: '1px solid #dee2e6' }}
            >
                <Spinner animation="border" size="sm" style={{ width: '10px', height: '10px' }} />
            </div>
        );
    }

    if (srcFoto) {
        return (
            <img
                src={srcFoto}
                alt={nome || "Usuário"}
                className="rounded-circle object-fit-cover flex-shrink-0"
                style={{ width: tamanho, height: tamanho, border: '1px solid #dee2e6', cursor: 'pointer' }}
                onClick={handleClick}
                title="Clique para ampliar a foto"
            />
        );
    }

    return (
        <div
            className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center fw-bold flex-shrink-0"
            style={{ width: tamanho, height: tamanho, fontSize: '0.75rem' }}
        >
            {nome ? nome.charAt(0).toUpperCase() : <i className="bi bi-person-fill"></i>}
        </div>
    );
};

function CentralChamados() {
    const [chamados, setChamados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroTipo, setFiltroTipo] = useState('loja');
    const [filtroStatus, setFiltroStatus] = useState('Todos');
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);
    const [fullscreenPdf, setFullscreenPdf] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");
    const [urlParaVisualizar, setUrlParaVisualizar] = useState("");

    const [showDetalhes, setShowDetalhes] = useState(false);
    const [showNovo, setShowNovo] = useState(false);

    const [chamadoSelecionado, setChamadoSelecionado] = useState(null);
    const [chamadoOrigemRecorrencia, setChamadoOrigemRecorrencia] = useState(null);
    const [interacoes, setInteracoes] = useState([]);
    const [anexosAbertura, setAnexosAbertura] = useState([]);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const [pdfSelecionado, setPdfSelecionado] = useState(null);

    // Estado para dados do equipamento vinculado
    const [dadosEquipamento, setDadosEquipamento] = useState(null);

    // ESTADOS PARA CONSULTA DO CHAMADO PAI
    const [showConsultaPai, setShowConsultaPai] = useState(false);
    const [chamadoPaiDados, setChamadoPaiDados] = useState(null);
    const [interacoesPai, setInteracoesPai] = useState([]);
    const [anexosPai, setAnexosPai] = useState([]);
    const [loadingPai, setLoadingPai] = useState(false);

    const [novaMsg, setNovaMsg] = useState("");
    const [anexosNovos, setAnexosNovos] = useState([]);
    const [enviandoInt, setEnviandoInt] = useState(false);

    const scrollRef = useRef(null);
    const chapa = localStorage.getItem("chapa");
    const lojap = localStorage.getItem("loja");

    const lojasPermitidas = JSON.parse(localStorage.getItem("lojasPermitidas") || "[]");
    const [lojaSelecionada, setLojaSelecionada] = useState(lojap);
    const lojaUser = lojaSelecionada;

    // Avaliação
    const [notaAvaliacao, setNotaAvaliacao] = useState(10);
    const [concordaSolucao, setConcordaSolucao] = useState(null);

    // Paginação e Timer
    const [pagina, setPagina] = useState(1);
    const [temMais, setTemMais] = useState(true);
    const [segundosParaAtualizar, setSegundosParaAtualizar] = useState(180);

    // Novos filtros de busca e listas dinâmicas
    const [listaSetores, setListaSetores] = useState([]);
    const [listaCategorias, setListaCategorias] = useState([]);

    const [filtroSetor, setFiltroSetor] = useState("");
    const [filtroCategoria, setFiltroCategoria] = useState("");
    const [filtroData, setFiltroData] = useState("");
    const [filtroNumChamado, setFiltroNumChamado] = useState("");
    const [filtroDescricao, setFiltroDescricao] = useState("");

    // Controle de visibilidade do painel retrátil
    const [showFiltrosAvancados, setShowFiltrosAvancados] = useState(false);

    // Função de download direto de ficheiros Base64
    const baixarFicheiroBase64 = (base64Data, nomeArquivo) => {
        try {
            const base64Limpo = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
            const byteCharacters = atob(base64Limpo.replace(/\r?\n|\r/g, ""));
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray]);

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nomeArquivo || 'download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            toast.success(`Download de ${nomeArquivo} iniciado!`);
        } catch (e) {
            console.error("Erro ao descarregar ficheiro:", e);
            toast.error("Erro ao efetuar o download do ficheiro.");
        }
    };

    // Renderizador genérico de cartões de anexos
    const renderCartaoAnexo = (nomeArquivo, base64) => {
        const nomeLower = (nomeArquivo || "").toLowerCase();
        const isPDF = nomeLower.endsWith(".pdf");
        const isPNG = nomeLower.endsWith(".png");
        const isTXT = nomeLower.endsWith('.txt') || nomeLower.endsWith('.txt_conv');
        const isExcel = nomeLower.endsWith('.xlsx') || nomeLower.endsWith('.xls') || nomeLower.endsWith('.csv');
        const isDoc = nomeLower.endsWith('.doc') || nomeLower.endsWith('.docx');

        let mimeType = isPNG ? "image/png" : (isPDF ? "application/pdf" : (isTXT ? "text/plain" : "image/jpeg"));

        return (
            <div
                className="ratio ratio-1x1 border rounded-3 overflow-hidden bg-white d-flex align-items-center justify-content-center shadow-sm"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    if (isPDF || isTXT) {
                        setPdfSelecionado({ base64, nome: nomeArquivo });
                    } else if (isExcel || isDoc) {
                        baixarFicheiroBase64(base64, nomeArquivo);
                    } else {
                        setFotoSelecionada({
                            foto: `data:${mimeType};base64,${base64}`,
                            nome: nomeArquivo,
                            info01: "Anexo do Chamado",
                            info02: nomeArquivo
                        });
                    }
                }}
            >
                {isPDF ? (
                    <div className="text-center text-danger fw-bold">
                        <i className="bi bi-file-earmark-pdf fs-1"></i>
                        <div style={{ fontSize: '0.7rem' }}>PDF</div>
                    </div>
                ) : isTXT ? (
                    <div className="text-center text-primary fw-bold">
                        <i className="bi bi-file-earmark-text fs-1"></i>
                        <div style={{ fontSize: '0.7rem' }}>TEXTO</div>
                    </div>
                ) : isExcel ? (
                    <div className="text-center text-success fw-bold p-1">
                        <i className="bi bi-file-earmark-excel fs-1"></i>
                        <div className="text-truncate" style={{ fontSize: '0.65rem' }} title={nomeArquivo}>EXCEL</div>
                    </div>
                ) : isDoc ? (
                    <div className="text-center text-primary fw-bold p-1">
                        <i className="bi bi-file-earmark-word fs-1"></i>
                        <div className="text-truncate" style={{ fontSize: '0.65rem' }} title={nomeArquivo}>WORD</div>
                    </div>
                ) : (
                    <img
                        src={`data:${mimeType};base64,${base64}`}
                        alt="anexo"
                        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                    />
                )}
            </div>
        );
    };

    const renderTextoComLinks = (texto) => {
        if (!texto) return "";
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const partes = texto.split(urlRegex);

        return partes.map((parte, index) => {
            if (parte.match(urlRegex)) {
                return (
                    <a
                        key={index}
                        href={parte}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ wordBreak: 'break-all', textDecoration: 'underline', color: '#8b0000' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {parte}
                    </a>
                );
            }
            return parte;
        });
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const idConsultaLink = queryParams.get("consulta");

        if (idConsultaLink) {
            abrirConsultaChamadoPai(null, idConsultaLink);
        }
    }, []);

    const abrirConsultaChamadoPai = async (e, idPai) => {
        if (e) e.stopPropagation();
        setLoadingPai(true);
        setShowConsultaPai(true);

        try {
            const resChamado = await api.get(`/chamado/${idPai}`);
            const dadosPai = Array.isArray(resChamado.data) ? resChamado.data[0] : resChamado.data;
            setChamadoPaiDados(dadosPai);

            const resInt = await api.get(`/chamado/${idPai}/interacoes`);
            const interacoesComAnexos = await Promise.all(
                (resInt.data || []).map(async (i) => {
                    try {
                        const idInteracao = i.ID_INTERACAO || i.id_interacao;
                        const resAnexo = await api.get(`/chamado/anexos?id=${idPai}&id_interacao=${idInteracao}`);
                        return { ...i, ANEXOS: resAnexo.data || [] };
                    } catch {
                        return { ...i, ANEXOS: [] };
                    }
                })
            );

            const resAnexos = await api.get(`/chamado/anexos?id=${idPai}&id_interacao=0`);
            setInteracoesPai(interacoesComAnexos);
            setAnexosPai(resAnexos.data || []);
        } catch (err) {
            console.error(err);
            toast.error("Erro ao carregar dados do chamado.");
        } finally {
            setLoadingPai(false);
        }
    };

    const handleFecharConsulta = () => {
        setShowConsultaPai(false);
        window.history.replaceState({}, document.title, window.location.pathname);
        if (!chapa) {
            window.location.href = "/arbor/login";
        }
    };

    useEffect(() => {
        const numSerie = chamadoSelecionado?.numero_serie || chamadoSelecionado?.NUMERO_SERIE;
        if (showDetalhes && numSerie && numSerie.trim() !== "" && numSerie.toUpperCase() !== "NÃO INFORMADO") {
            api.get(`/chamado/equipamento/${encodeURIComponent(numSerie.trim())}`)
                .then(res => setDadosEquipamento(res.data))
                .catch(() => setDadosEquipamento(null));
        } else {
            setDadosEquipamento(null);
        }
    }, [showDetalhes, chamadoSelecionado]);

    useEffect(() => {
        async function carregarSetores() {
            try {
                const res = await api.get('/chamados/setores');
                setListaSetores(res.data || []);
            } catch (err) {
                console.error("Erro ao buscar setores", err);
            }
        }
        carregarSetores();
    }, []);

    useEffect(() => {
        if (filtroSetor) {
            api.get(`/chamados/categorias?setor=${filtroSetor}`)
                .then(res => setListaCategorias(res.data || []))
                .catch(err => console.error("Erro ao carregar categorias", err));
        } else {
            setListaCategorias([]);
            setFiltroCategoria("");
        }
    }, [filtroSetor]);

    useEffect(() => {
        if (showDetalhes) {
            setNovaMsg("");
            setAnexosNovos([]);
            setNotaAvaliacao(10);
            setConcordaSolucao(null);
        }
    }, [showDetalhes]);

    const formatarNomePrimeiro = (nome) => {
        if (!nome) return "";
        const primeiro = nome.split(" ")[0].toLowerCase();
        return primeiro.charAt(0).toUpperCase() + primeiro.slice(1);
    };

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [interacoes, showDetalhes]);

    const formatarData = (isoString) => {
        if (!isoString) return "";

        const data = isoString.replace("Z", "");
        const dt = new Date(data);

        const dia = String(dt.getDate()).padStart(2, "0");
        const mes = String(dt.getMonth() + 1).padStart(2, "0");
        const ano = dt.getFullYear();
        const hora = String(dt.getHours()).padStart(2, "0");
        const minuto = String(dt.getMinutes()).padStart(2, "0");
        const segundo = String(dt.getSeconds()).padStart(2, "0");

        return `${dia}/${mes}/${ano} - ${hora}:${minuto}:${segundo}`;
    };

    const carregarChamados = useCallback(async (novaPagina = 1, acumular = false) => {
        if (!acumular) {
            setLoading(true);
        }

        try {
            const pUser = filtroTipo === 'meus' ? chapa : '';
            const pLoja = filtroTipo === 'meus' ? -1 : lojaSelecionada;

            let statusId = -1;
            let usr = "";
            if (filtroStatus === "Abertos") {
                statusId = 0; usr = "T";
            } else if (filtroStatus === "Aguardando Retorno") {
                usr = "U";
            } else if (filtroStatus === "Aguardando Avaliação") {
                statusId = 90; usr = "X";
            } else if (filtroStatus === "Fechados") {
                statusId = 99; usr = "X";
            } else if (filtroStatus === "Cancelados") {
                statusId = 98; usr = "X";
            }

            const res = await api.get(`/chamados`, {
                params: {
                    depend: usr,
                    loja: pLoja,
                    usuario: pUser,
                    status: statusId,
                    setor: filtroSetor ? Number(filtroSetor) : -1,
                    pagina: novaPagina,
                    limite: 15,
                    categoriaChamado: filtroCategoria,
                    dataChamado: filtroData,
                    numChamado: filtroNumChamado === "" ? 0 : Number(filtroNumChamado),
                    descricaoChamado: filtroDescricao
                }
            });

            const novosChamados = Array.isArray(res.data) ? res.data : [];

            if (acumular) {
                setChamados(prev => [...prev, ...novosChamados]);
            } else {
                setChamados(novosChamados);
            }

            setTemMais(novosChamados.length === 15);
            setPagina(novaPagina);

        } catch (err) {
            console.error(err);
            if (!acumular) toast.error("Erro ao carregar lista de chamados");
        } finally {
            setLoading(false);
        }
    }, [filtroTipo, filtroStatus, lojaSelecionada, filtroSetor, filtroCategoria, filtroData, filtroNumChamado, filtroDescricao, chapa]);

    useEffect(() => {
        carregarChamados(1, false);
    }, [carregarChamados, filtroSetor, filtroCategoria, filtroData, filtroNumChamado, filtroDescricao]);

    useEffect(() => {
        setLojaSelecionada(lojaUser);
    }, []);

    useEffect(() => {
        if (chapa) {
            const intervalo = setInterval(() => {
                setSegundosParaAtualizar((prev) => {
                    if (prev <= 1) {
                        carregarChamados(1, false);
                        return 180;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(intervalo);
        }
    }, [chapa, carregarChamados]);

    const decodeBase64 = (str) => {
        try {
            if (!str || typeof str !== "string") return "";
            let base64 = str.replace(/\s/g, "");
            const binary = window.atob(base64);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            try {
                return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
            } catch (e) {
                return new TextDecoder("iso-8859-1").decode(bytes);
            }
        } catch (e) { return str; }
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + anexosNovos.length > 3) {
            toast.warning("Máximo de 3 anexos permitidos");
            return;
        }

        files.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setAnexosNovos(prev => [...prev, {
                    NOME_ARQUIVO: file.name,
                    TIPO_ARQUIVO: file.type,
                    BASE64: reader.result.split(',')[1]
                }]);
            };
            reader.readAsDataURL(file);
        });
    };

    const abrirDetalhes = async (chamado) => {
        setChamadoSelecionado(chamado);
        setShowDetalhes(true);
        setLoadingDetalhes(true);

        const id = chamado.id_chamado || chamado.ID_CHAMADO;

        try {
            const resInt = await api.get(`/chamado/${id}/interacoes`);

            const interacoesComAnexos = await Promise.all(
                (resInt.data || []).map(async (i) => {
                    try {
                        const idInteracao = i.ID_INTERACAO || i.id_interacao;
                        const resAnexo = await api.get(`/chamado/anexos?id=${id}&id_interacao=${idInteracao}`);
                        return {
                            ...i,
                            ANEXOS: resAnexo.data || []
                        };
                    } catch {
                        return { ...i, ANEXOS: [] };
                    }
                })
            );

            const resAnexos = await api.get(`/chamado/anexos?id=${id}&id_interacao=0`);

            setInteracoes(interacoesComAnexos);
            setAnexosAbertura(resAnexos.data || []);
        } catch {
            setInteracoes([]);
            setAnexosAbertura([]);
        } finally {
            setLoadingDetalhes(false);
        }
    };

    const enviarInteracao = async () => {
        if (!novaMsg.trim() && anexosNovos.length === 0) {
            toast.warning("Digite uma mensagem ou anexe um arquivo.");
            return;
        }

        setEnviandoInt(true);

        try {
            const id = chamadoSelecionado?.id_chamado || chamadoSelecionado?.ID_CHAMADO;
            const dpSetor = (chamadoSelecionado?.dp_setor || chamadoSelecionado?.DP_SETOR || "").toString().toUpperCase();
            const statusAtual = chamadoSelecionado?.status !== undefined ? chamadoSelecionado.status : chamadoSelecionado?.STATUS;

            let statusParaEnviar = statusAtual;

            if (statusAtual === 90) {
                if (concordaSolucao === 'SIM') {
                    statusParaEnviar = 99;
                } else if (concordaSolucao === 'NAO') {
                    statusParaEnviar = 0;
                }
            } else {
                if (statusAtual < 90 && dpSetor === 'U') {
                    statusParaEnviar = 0;
                }
            }

            const payload = {
                id_chamado: parseInt(id),
                usuario: chapa,
                perfil: 'USUARIO',
                mensagem: novaMsg,
                status_novo: statusParaEnviar,
                nota: statusParaEnviar === 99 ? notaAvaliacao : null,
                anexos: anexosNovos.map(a => ({
                    nome: a.NOME_ARQUIVO || a.nome,
                    base64: a.BASE64 || a.base64
                }))
            };

            await api.post('/interacao', payload);

            let tituloSwal = "Enviado!";
            let textoSwal = "Sua interação foi registrada com sucesso.";
            let iconeSwal = "success";

            if (statusParaEnviar === 99) {
                tituloSwal = "Chamado Finalizado!";
                textoSwal = "Obrigado por avaliar nosso atendimento.";
            } else if (statusParaEnviar === 0 && concordaSolucao === 'NAO') {
                tituloSwal = "Chamado Reaberto!";
                textoSwal = "Sua contestação foi enviada para a equipe técnica.";
                iconeSwal = "warning";
            }

            await Swal.fire({
                title: tituloSwal,
                text: textoSwal,
                icon: iconeSwal,
                confirmButtonColor: '#8b0000',
                confirmButtonText: 'OK'
            });

            setNovaMsg("");
            setAnexosNovos([]);
            setConcordaSolucao(null);

            if (statusParaEnviar === 99 || statusParaEnviar === 0) {
                setShowDetalhes(false);
                carregarChamados(1, false);
            } else {
                abrirDetalhes(chamadoSelecionado);
            }

        } catch (err) {
            console.error(err);
            Swal.fire("Erro!", "Não foi possível salvar sua interação.", "error");
        } finally {
            setEnviandoInt(false);
        }
    };

    useEffect(() => {
        if (pdfSelecionado?.base64) {
            const base64Limpo = pdfSelecionado.base64.split(',')[1] || pdfSelecionado.base64;
            try {
                const byteCharacters = atob(base64Limpo);
                const byteNumbers = new Uint8Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const nomeArquivo = (pdfSelecionado.nome || "").toLowerCase();

                const isTxt =
                    nomeArquivo.endsWith('.txt') ||
                    nomeArquivo.endsWith('.txt_conv');

                const tipoMime = isTxt ? 'text/plain' : 'application/pdf';

                const blob = new Blob([byteNumbers], { type: tipoMime });
                const url = URL.createObjectURL(blob);

                setUrlParaVisualizar(url);

                return () => URL.revokeObjectURL(url);
            } catch (e) {
                console.error("Erro ao converter anexo:", e);
            }
        }
    }, [pdfSelecionado]);

    return (
        <div style={{ paddingTop: '80px', minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa' }}>
            <Menu modulo="ARBOR" />
            <Container className="flex-grow-1">
                {/* CABEÇALHO PRINCIPAL DA PÁGINA */}
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4 mt-3 bg-white p-3 rounded-3 shadow-sm border">
                    <div>
                        <h4 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                            <i className="bi bi-headset" style={{ color: '#8b0000' }}></i>
                            Chamados
                        </h4>
                        <div className="d-flex align-items-center gap-2 mt-1">
                            <small className="text-muted fw-bold">Loja / Setor:</small>
                            <Form.Select
                                size="sm"
                                style={{ width: '150px' }}
                                value={lojaSelecionada}
                                onChange={(e) => setLojaSelecionada(e.target.value)}
                                disabled={filtroTipo === 'meus'}
                                className="fw-semibold"
                            >
                                {lojasPermitidas.map(loja => (
                                    <option key={loja} value={loja}>{loja}</option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                    <Button
                        style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                        className="fw-bold shadow-sm d-none d-md-inline-flex align-items-center gap-1"
                        onClick={() => {
                            setChamadoOrigemRecorrencia(null);
                            setShowNovo(true);
                        }}
                    >
                        <i className="bi bi-plus-lg me-1"></i>Novo Chamado
                    </Button>
                    <Button
                        style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                        className="btn-floating-mobile d-md-none shadow-lg"
                        onClick={() => {
                            setChamadoOrigemRecorrencia(null);
                            setShowNovo(true);
                        }}
                    >
                        <i className="bi bi-plus-lg"></i>
                    </Button>
                </div>

                {/* FILTROS PRINCIPAIS */}
                <div className="d-flex flex-column align-items-center mb-4 gap-3">
                    <ButtonGroup className="shadow-sm bg-white p-1 rounded-pill d-flex justify-content-center w-100 border">
                        {['loja', 'meus'].map((tipo) => (
                            <ToggleButton
                                key={tipo}
                                type="radio"
                                style={filtroTipo === tipo ? { backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' } : { color: '#495057', backgroundColor: 'transparent', border: 'none' }}
                                className="rounded-pill px-4 fw-bold"
                                value={tipo}
                                checked={filtroTipo === tipo}
                                onClick={() => setFiltroTipo(tipo)}
                                onChange={() => { }}
                            >
                                {tipo === 'loja' ? 'Minha Loja' : 'Meus Chamados'}
                            </ToggleButton>
                        ))}
                    </ButtonGroup>

                    {/* BARRA DE STATUS */}
                    <div className="w-100">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="small text-muted fw-bold d-md-none">Filtrar por Status:</span>
                            <Button
                                variant={showFiltrosAvancados ? "secondary" : "outline-secondary"}
                                size="sm"
                                onClick={() => setShowFiltrosAvancados(!showFiltrosAvancados)}
                                className="d-flex align-items-center gap-1 ms-auto shadow-sm fw-semibold"
                                style={{ height: '34px', borderRadius: '20px' }}
                            >
                                <i className={`bi ${showFiltrosAvancados ? 'bi-chevron-up' : 'bi-sliders'}`}></i>
                                <span>{showFiltrosAvancados ? "Ocultar" : "Filtros Avançados"}</span>
                                {(filtroNumChamado || filtroSetor || filtroCategoria || filtroData || filtroDescricao) && (
                                    <Badge bg="danger" className="ms-1">Ativo</Badge>
                                )}
                            </Button>
                        </div>

                        <div className="status-container-scroll w-100 overflow-auto pb-1">
                            <ButtonGroup size="sm" className="shadow-sm bg-white p-1 rounded-pill d-inline-flex border">
                                {["Todos", "Abertos", "Aguardando Retorno", "Aguardando Avaliação", "Fechados", "Cancelados"].map((st) => (
                                    <ToggleButton
                                        key={st}
                                        type="radio"
                                        style={filtroStatus === st ? { backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' } : { color: '#495057', backgroundColor: 'transparent', border: 'none' }}
                                        className="rounded-pill px-3 text-nowrap fw-semibold"
                                        value={st}
                                        checked={filtroStatus === st}
                                        onClick={() => setFiltroStatus(st)}
                                        onChange={() => { }}
                                    >
                                        {st}
                                    </ToggleButton>
                                ))}
                            </ButtonGroup>
                        </div>
                    </div>
                </div>

                {/* FILTROS AVANÇADOS */}
                <Collapse in={showFiltrosAvancados}>
                    <div>
                        <Card className="p-3 mb-4 border-0 bg-white rounded-3 shadow-sm border">
                            <div className="fw-bold mb-2 text-secondary d-flex justify-content-between align-items-center" style={{ fontSize: '0.85rem' }}>
                                <span><i className="bi bi-funnel-fill me-1" style={{ color: '#8b0000' }}></i> Filtros de Busca Avançados</span>
                                {(filtroNumChamado || filtroSetor || filtroCategoria || filtroData || filtroDescricao) && (
                                    <span
                                        className="text-danger fw-bold"
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={() => {
                                            setFiltroNumChamado("");
                                            setFiltroSetor("");
                                            setFiltroCategoria("");
                                            setFiltroData("");
                                            setFiltroDescricao("");
                                        }}
                                    >
                                        Limpar tudo
                                    </span>
                                )}
                            </div>
                            <Row className="g-2">
                                <Col xs={6} md={2}>
                                    <Form.Group>
                                        <Form.Label className="small text-muted mb-1">Nº Chamado</Form.Label>
                                        <Form.Control
                                            type="number"
                                            size="sm"
                                            placeholder="Ex: 154"
                                            value={filtroNumChamado}
                                            onChange={(e) => setFiltroNumChamado(e.target.value)}
                                            style={{ height: '38px', borderRadius: '6px' }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs={6} md={2}>
                                    <Form.Group>
                                        <Form.Label className="small text-muted mb-1">Setor</Form.Label>
                                        <Form.Select
                                            size="sm"
                                            value={filtroSetor}
                                            onChange={(e) => setFiltroSetor(e.target.value)}
                                            style={{ height: '38px', borderRadius: '6px' }}
                                        >
                                            <option value="">Todos os Setores</option>
                                            {listaSetores.map((s, idx) => (
                                                <option key={idx} value={s.id_setor || s.codigo}>
                                                    {s.nome_setor || s.descricao}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col xs={6} md={3}>
                                    <Form.Group>
                                        <Form.Label className="small text-muted mb-1">Categoria</Form.Label>
                                        <Form.Select
                                            size="sm"
                                            value={filtroCategoria}
                                            onChange={(e) => setFiltroCategoria(e.target.value)}
                                            disabled={!filtroSetor}
                                            style={{ height: '38px', borderRadius: '6px' }}
                                        >
                                            <option value="">{filtroSetor ? "Todas as Categorias" : "Selecione um Setor"}</option>
                                            {listaCategorias.map((cat, idx) => (
                                                <option key={idx} value={cat.nome_categoria || cat.descricao}>
                                                    {cat.nome_categoria || cat.descricao}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col xs={6} md={2}>
                                    <Form.Group>
                                        <Form.Label className="small text-muted mb-1">Data Abertura</Form.Label>
                                        <Form.Control
                                            type="date"
                                            size="sm"
                                            value={filtroData}
                                            onChange={(e) => setFiltroData(e.target.value)}
                                            style={{ height: '38px', borderRadius: '6px' }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col xs={12} md={3}>
                                    <Form.Group>
                                        <Form.Label className="small text-muted mb-1">Termo de busca</Form.Label>
                                        <div className="d-flex gap-2">
                                            <Form.Control
                                                type="text"
                                                size="sm"
                                                placeholder="Buscar assunto/descrição..."
                                                value={filtroDescricao}
                                                onChange={(e) => setFiltroDescricao(e.target.value)}
                                                style={{ height: '38px', borderRadius: '6px' }}
                                            />
                                            {(filtroNumChamado || filtroSetor || filtroCategoria || filtroData || filtroDescricao) && (
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    title="Limpar filtros"
                                                    style={{ height: '38px', width: '42px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '6px' }}
                                                    onClick={() => {
                                                        setFiltroNumChamado("");
                                                        setFiltroSetor("");
                                                        setFiltroCategoria("");
                                                        setFiltroData("");
                                                        setFiltroDescricao("");
                                                    }}
                                                >
                                                    <i className="bi bi-trash3-fill"></i>
                                                </Button>
                                            )}
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card>
                    </div>
                </Collapse>

                {/* CARDS DE CHAMADOS */}
                {loading ? (
                    <div className="text-center mt-5"><Spinner animation="border" style={{ color: '#8b0000' }} /></div>
                ) : (
                    <Row>
                        {chamados.map(c => {
                            const idOrigem = c.id_chamado_origem || c.ID_CHAMADO_ORIGEM;

                            // Mapeamento abrangente priorizando usuario_atendendo enviado no JSON
                            const chapaUltimo =
                                c.ultima_chapa_interacao ||
                                c.ULTIMA_CHAPA_INTERACAO ||
                                c.usuario_atendendo ||
                                c.USUARIO_ATENDENDO ||
                                c.chapa_interacao ||
                                c.chapa ||
                                c.CHAPA;

                            const nomeUltimo =
                                c.ultima_nome_interacao ||
                                c.ULTIMA_NOME_INTERACAO ||
                                c.nome_atendendo ||
                                c.NOME_ATENDENDO ||
                                c.nome_usuario ||
                                c.NOME_USUARIO;

                            return (
                                <Col md={4} key={c.id_chamado || c.ID_CHAMADO} className="mb-4">
                                    <Card className="h-100 shadow-sm border-0 d-flex flex-column justify-content-between" onClick={() => abrirDetalhes(c)} style={{ cursor: 'pointer', borderRadius: '12px' }}>
                                        <div>
                                            <div style={{ height: '6px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', backgroundColor: c.cor_hex || c.COR_HEX || '#8b0000' }} />
                                            <Card.Body>
                                                <div className="d-flex justify-content-between mb-2 align-items-center">
                                                    <Badge style={{ backgroundColor: c.cor_hex || c.COR_HEX || '#8b0000' }}>{c.status_nome || c.STATUS_NOME}
                                                        {c.nota_avaliacao > 0 && c.status === 99 ? (
                                                            <span>
                                                                <b> - Nota: </b>
                                                                {c.nota_avaliacao || c.NOTA_AVALIACAO}
                                                            </span>
                                                        ) : null}
                                                    </Badge>
                                                    <div className="text-muted small fw-bold">
                                                        #{c.id_chamado || c.ID_CHAMADO}
                                                        {idOrigem && (
                                                            <Badge bg="warning" text="dark" className="ms-1" onClick={(e) => abrirConsultaChamadoPai(e, idOrigem)} title="Clique para ver o Chamado Origem">
                                                                <i className="bi bi-link-45deg me-1"></i>Pai: #{idOrigem}
                                                            </Badge>
                                                        )}
                                                    </div>
                                                </div>
                                                <Card.Title className="h6 fw-bold text-dark">{c.assunto || c.ASSUNTO}</Card.Title>
                                                <div className="bg-light p-2 rounded small mb-2 border" style={{ fontSize: '0.75rem' }}>
                                                    <div><strong>Setor:</strong> {c.nome_setor || c.NOME_SETOR}</div>
                                                    <div><strong>Loja:</strong> {String(c.loja).padStart(2, '0') || String(c.LOJA).padStart(2, '0')}</div>

                                                    {(c.numero_serie || c.NUMERO_SERIE) && (
                                                        <div><strong>Nº Série:</strong> <span className="text-uppercase fw-bold text-danger">{c.numero_serie || c.NUMERO_SERIE}</span></div>
                                                    )}

                                                    <div className="mt-1" style={{ color: '#8b0000' }}>
                                                        <i className="bi bi-clock me-1"></i>{formatarData(c.data_abertura || c.DATA_ABERTURA)}
                                                    </div>
                                                </div>
                                                <Card.Text className="small text-muted text-truncate">{decodeBase64(c.descricao || c.DESCRICAO)}</Card.Text>
                                            </Card.Body>
                                        </div>

                                        <Card.Footer className="bg-white border-top-0 pt-0 pb-3 px-3 d-flex align-items-center justify-content-between">
                                            <div style={{ fontSize: '0.75rem', color: '#666' }} className="text-truncate me-2">
                                                {c.ultima_data_interacao ? (
                                                    <>
                                                        <i className="bi bi-reply-all me-1"></i>
                                                        <b>Última resposta: </b>{formatarData(c.ultima_data_interacao)} - <b>Usuário: </b>{formatarNomePrimeiro(c.ultima_nome_interacao)}
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="bi bi-person me-1"></i>
                                                        <b>Solicitante: </b>{formatarNomePrimeiro(c.nome_usuario || c.NOME_USUARIO)}
                                                    </>
                                                )}
                                            </div>
                                            <AvatarUsuarioApi
                                                chapa={chapaUltimo}
                                                nome={nomeUltimo}
                                                tamanho="32px"
                                                onSelectFoto={(dadosFoto) => setFotoSelecionada(dadosFoto)}
                                            />
                                        </Card.Footer>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                )}

                {temMais && (
                    <div className="d-flex justify-content-center my-4">
                        <Button
                            variant="outline-danger"
                            className="fw-bold px-4"
                            onClick={() => carregarChamados(pagina + 1, true)}
                            disabled={loading}
                        >
                            {loading ? "Carregando..." : "Ver mais chamados"}
                        </Button>
                    </div>
                )}
            </Container>

            {/* MODAL DETALHES DO CHAMADO */}
            <Modal
                show={showDetalhes}
                onHide={() => setShowDetalhes(false)}
                size="lg"
                centered
                className="modal-fullscreen-mobile"
                style={{ zIndex: 10550 }}
            >
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white">
                        #{chamadoSelecionado?.id_chamado || chamadoSelecionado?.ID_CHAMADO} - {chamadoSelecionado?.assunto || chamadoSelecionado?.ASSUNTO}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body ref={scrollRef} style={{ backgroundColor: '#f8f9fa', maxHeight: '65vh', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>

                    <div className="d-flex justify-content-start mb-4">
                        <div className="shadow-sm p-3 border rounded-3" style={{
                            borderRadius: '0 15px 15px 15px',
                            maxWidth: '85%',
                            backgroundColor: '#ffffff'
                        }}>

                            <div className="border-bottom border-dark border-opacity-10 mb-2 pb-1">
                                <div className="d-flex align-items-center gap-2">
                                    <AvatarUsuarioApi
                                        chapa={chamadoSelecionado?.chapa || chamadoSelecionado?.CHAPA || chamadoSelecionado?.chapa_solicitante || chamadoSelecionado?.CHAPA_SOLICITANTE || chamadoSelecionado?.chapa_usuario || chamadoSelecionado?.CHAPA_USUARIO || chamadoSelecionado?.usuario || chamadoSelecionado?.USUARIO || chamadoSelecionado?.cod_usuario || chamadoSelecionado?.COD_USUARIO}
                                        nome={chamadoSelecionado?.nome_usuario || chamadoSelecionado?.NOME_USUARIO}
                                        tamanho="26px"
                                        onSelectFoto={(dadosFoto) => setFotoSelecionada(dadosFoto)}
                                    />
                                    <span className="fw-bold small" style={{ color: '#8b0000' }}>
                                        {formatarNomePrimeiro(chamadoSelecionado?.nome_usuario || chamadoSelecionado?.NOME_USUARIO)}
                                    </span>

                                    <Badge style={{ backgroundColor: chamadoSelecionado?.cor_hex || chamadoSelecionado?.COR_HEX || '#8b0000' }}>
                                        {chamadoSelecionado?.status_nome || chamadoSelecionado?.STATUS_NOME}
                                    </Badge>
                                </div>
                            </div>

                            {(chamadoSelecionado?.id_chamado_origem || chamadoSelecionado?.ID_CHAMADO_ORIGEM) && (
                                <div className="mb-2">
                                    <Badge
                                        bg="warning"
                                        text="dark"
                                        className="p-2 fw-bold"
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => abrirConsultaChamadoPai(e, chamadoSelecionado?.id_chamado_origem || chamadoSelecionado?.ID_CHAMADO_ORIGEM)}
                                        title="Clique para visualizar o Chamado Pai (Apenas Consulta)"
                                    >
                                        <i className="bi bi-link-45deg me-1"></i>
                                        Relacionado ao Chamado Original: #{chamadoSelecionado?.id_chamado_origem || chamadoSelecionado?.ID_CHAMADO_ORIGEM} (Clique para abrir)
                                    </Badge>
                                </div>
                            )}

                            <div className="small mb-2 text-dark">
                                <strong>Setor:</strong> {chamadoSelecionado?.nome_setor || chamadoSelecionado?.NOME_SETOR} <br />
                                <strong>Loja:</strong> {String(chamadoSelecionado?.loja).padStart(2, '0') || String(chamadoSelecionado?.LOJA).padStart(2, '0')} <br />
                                <strong>Categoria:</strong> {chamadoSelecionado?.categoria_nome || chamadoSelecionado?.CATEGORIA_NOME}

                                {(chamadoSelecionado?.numero_serie || chamadoSelecionado?.NUMERO_SERIE) && (
                                    <>
                                        <br />
                                        <strong>Nº Série / Patrimônio:</strong> <Badge style={{ backgroundColor: '#8b0000' }} className="text-uppercase me-1">{chamadoSelecionado?.numero_serie || chamadoSelecionado?.NUMERO_SERIE}</Badge>
                                    </>
                                )}
                            </div>

                            {/* CARD DE EXIBIÇÃO AUTOMÁTICA DOS DADOS DO EQUIPAMENTO ENCONTRADO */}
                            {dadosEquipamento && (
                                <div className="bg-light p-2.5 rounded-3 border border-danger border-opacity-25 mb-3 shadow-sm">
                                    <h6 className="fw-bold text-danger mb-2 small d-flex align-items-center">
                                        <i className="bi bi-pc-display me-1 fs-6"></i> Equipamento Vinculado no Sistema
                                    </h6>
                                    <Row className="g-1 text-secondary" style={{ fontSize: '0.8rem' }}>
                                        <Col xs={6}><strong>Tipo:</strong> {dadosEquipamento.EQP_TIPO || dadosEquipamento.eqp_tipo || "N/I"}</Col>
                                        <Col xs={6}><strong>Marca/Modelo:</strong> {dadosEquipamento.EQP_MARCA || dadosEquipamento.eqp_marca || ""} {dadosEquipamento.EQP_MODELO || dadosEquipamento.eqp_modelo || ""}</Col>
                                        <Col xs={6}><strong>Status:</strong> <Badge bg="secondary">{dadosEquipamento.DESC_STATUS || dadosEquipamento.desc_status || "N/I"}</Badge></Col>
                                        <Col xs={6}><strong>Alocado em:</strong> {dadosEquipamento.NOME_USUARIO || dadosEquipamento.NOME_LOJA || dadosEquipamento.nome_loja || "Sem vínculo"}</Col>
                                    </Row>
                                </div>
                            )}

                            <div className="small text-dark mb-2" style={{ whiteSpace: 'pre-wrap' }}>
                                {renderTextoComLinks(decodeBase64(chamadoSelecionado?.descricao || chamadoSelecionado?.DESCRICAO))}
                            </div>

                            {anexosAbertura.length > 0 && (
                                <Row className="g-1">
                                    {anexosAbertura.map((f, i) => {
                                        const nomeArquivo = f.NOME_ARQUIVO || f.nome || "";
                                        let base64 = (f.BASE64 || f.base64 || "").replace(/\r?\n|\r/g, "");
                                        return (
                                            <Col xs={4} key={i}>
                                                {renderCartaoAnexo(nomeArquivo, base64)}
                                            </Col>
                                        );
                                    })}
                                </Row>
                            )}
                            <div className="text-end mt-1">
                                <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                                    {formatarData(chamadoSelecionado?.data_abertura || chamadoSelecionado?.DATA_ABERTURA)}
                                </small>
                            </div>
                        </div>
                    </div>

                    {interacoes.map((i, idx) => {
                        const usuarioInteracao = i.CHAPA || i.USUARIO || i.usuario || i.chapa;
                        const isMe = String(usuarioInteracao).trim() === String(chapa).trim();
                        const listAnexos = i.ANEXOS || i.anexos || [];

                        return (
                            <div
                                key={idx}
                                style={{
                                    display: 'flex',
                                    justifyContent: isMe ? 'flex-end' : 'flex-start',
                                    paddingLeft: isMe ? '40px' : '8px',
                                    paddingRight: isMe ? '8px' : '40px',
                                    marginBottom: '6px'
                                }}
                            >
                                <div
                                    className="position-relative border shadow-sm"
                                    style={{
                                        borderRadius: isMe
                                            ? '12px 12px 4px 12px'
                                            : '12px 12px 12px 4px',
                                        backgroundColor: isMe ? '#f8d7da' : '#ffffff',
                                        maxWidth: '65%',
                                        padding: '8px 12px',
                                        display: 'inline-block'
                                    }}
                                >
                                    <div className="d-flex align-items-center gap-1 mb-1" style={{ fontSize: '0.7rem' }}>
                                        <AvatarUsuarioApi
                                            chapa={usuarioInteracao}
                                            nome={isMe ? 'Você' : (i.NOME_USUARIO || i.nome_usuario)}
                                            tamanho="22px"
                                            onSelectFoto={(dadosFoto) => setFotoSelecionada(dadosFoto)}
                                        />
                                        <span className={`fw-bold ${isMe ? 'text-danger' : 'text-dark'}`}>
                                            {isMe ? 'Você' : formatarNomePrimeiro(i.NOME_USUARIO || i.nome_usuario)}
                                        </span>

                                        <Badge bg="secondary" style={{ fontSize: '0.55rem' }}>
                                            {i.STATUS_NOME || i.status_nome}
                                        </Badge>
                                    </div>

                                    <div
                                        style={{
                                            fontSize: '0.8rem',
                                            color: '#111',
                                            whiteSpace: 'pre-wrap',
                                            lineHeight: '1.3'
                                        }}
                                    >
                                        {renderTextoComLinks(decodeBase64(i.MENSAGEM || i.mensagem))}
                                    </div>

                                    {listAnexos.length > 0 && (
                                        <Row className="g-1 mt-2">
                                            {listAnexos.map((f, k) => {
                                                const nomeArquivo = f.nome || f.NOME_ARQUIVO || "";
                                                let base64 = (f.base64 || f.BASE64 || "").replace(/\r?\n|\r/g, "");
                                                return (
                                                    <Col xs={4} key={k}>
                                                        {renderCartaoAnexo(nomeArquivo, base64)}
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    )}
                                    {chamadoSelecionado?.nota_avaliacao > 0 && (i.status_novo === 99 || i.STATUS_NOVO === 99) ? (
                                        <div className="mt-2">
                                            <Badge style={{ backgroundColor: '#8b0000' }}>
                                                <b>Nota: </b>{chamadoSelecionado?.nota_avaliacao || chamadoSelecionado?.NOTA_AVALIACAO}
                                            </Badge>
                                        </div>
                                    ) : null}

                                    <div className="text-end mt-1" style={{ opacity: 0.6 }}>
                                        <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                                            {i.descricao} - {formatarData(i.DATA_INTEGRATION || i.data_interacao)}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    {loadingDetalhes && (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                            <div className="text-center">
                                <Spinner animation="border" style={{ color: '#8b0000' }} />
                                <div className="mt-2 text-muted small">Carregando interações...</div>
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <div className="p-3 border-top bg-white">
                    {(chamadoSelecionado?.STATUS === 90 || chamadoSelecionado?.status === 90) &&
                        (chamadoSelecionado?.DP_SETOR === 'X' || chamadoSelecionado?.dp_setor === 'X') &&
                        !chamadoSelecionado?.NOTA_AVALIACAO && concordaSolucao !== 'NAO' ? (

                        <div className="p-2 border rounded-3 bg-light shadow-sm">
                            {concordaSolucao === null ? (
                                <div className="text-center py-2">
                                    <h6 className="mb-3 fw-bold text-dark">Você concorda com a solução apresentada?</h6>
                                    <div className="d-flex gap-2 justify-content-center">
                                        <Button
                                            variant="outline-danger"
                                            className="px-4 fw-bold"
                                            onClick={() => setConcordaSolucao('NAO')}
                                        >
                                            <i className="bi bi-hand-thumbs-down me-2"></i>Não, Reabrir
                                        </Button>
                                        <Button
                                            style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                            className="px-4 fw-bold"
                                            onClick={() => setConcordaSolucao('SIM')}
                                        >
                                            <i className="bi bi-hand-thumbs-up me-2"></i>Sim, Avaliar
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <span className="small fw-bold text-danger">Avalie o Atendimento (Nota: {notaAvaliacao})</span>
                                        <Button variant="link" size="sm" className="p-0 text-decoration-none text-secondary fw-bold" onClick={() => setConcordaSolucao(null)}>Voltar</Button>
                                    </div>
                                    <Row className="align-items-center g-2">
                                        <Col xs={5}>
                                            <Form.Range
                                                min={1} max={10} value={notaAvaliacao}
                                                onChange={(e) => setNotaAvaliacao(Number(e.target.value))}
                                            />
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Control
                                                size="sm"
                                                placeholder="Comentário..."
                                                value={novaMsg}
                                                onChange={(e) => setNovaMsg(e.target.value)}
                                            />
                                        </Col>
                                        <Col xs={2}>
                                            <Button
                                                style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                                size="sm"
                                                className="w-100 fw-bold"
                                                onClick={enviarInteracao}
                                                disabled={!novaMsg.trim() || enviandoInt}
                                            >
                                                {enviandoInt ? <Spinner size="sm" /> : <i className="bi bi-check-lg"></i>}
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>

                    ) : (
                        <>
                            {/* AVISO E BOTÃO RECORRÊNCIA QUANDO O CHAMADO ESTÁ ENCERRADO */}
                            {(chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X" || chamadoSelecionado?.status >= 90) && (
                                <div className="p-2 mb-2 rounded border bg-light d-flex flex-wrap align-items-center justify-content-between gap-2" style={{ fontSize: '0.82rem' }}>
                                    <span className="text-muted fw-bold">
                                        <i className="bi bi-lock-fill me-1 text-secondary"></i>
                                        Este chamado foi finalizado!
                                    </span>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        className="fw-bold"
                                        onClick={() => {
                                            setChamadoOrigemRecorrencia(chamadoSelecionado);
                                            setShowDetalhes(false);
                                            setShowNovo(true);
                                        }}
                                    >
                                        <i className="bi bi-arrow-repeat me-1"></i>
                                        Abrir Chamado Recorrente
                                    </Button>
                                </div>
                            )}

                            {concordaSolucao === 'NAO' && (
                                <div className="alert alert-danger py-1 px-2 mb-2 d-flex justify-content-between align-items-center" style={{ fontSize: '0.8rem' }}>
                                    <span><strong>Modo Reabertura:</strong> Justifique e anexe arquivos se necessário.</span>
                                    <Button variant="link" size="sm" className="p-0 text-danger fw-bold" onClick={() => setConcordaSolucao(null)}>Cancelar</Button>
                                </div>
                            )}

                            {anexosNovos.length > 0 && (
                                <div className="d-flex flex-wrap gap-2 mb-2">
                                    {anexosNovos.map((a, idx) => (
                                        <Badge key={idx} style={{ backgroundColor: '#8b0000' }} className="d-flex align-items-center p-2">
                                            <i className="bi bi-paperclip me-1"></i>
                                            {a.NOME_ARQUIVO.substring(0, 15)}...
                                            <i className="bi bi-x-circle ms-2" style={{ cursor: 'pointer' }} onClick={() => setAnexosNovos(prev => prev.filter((_, i) => i !== idx))}></i>
                                        </Badge>
                                    ))}
                                </div>
                            )}

                            <div className="mt-1">
                                <InputGroup className={`shadow-sm border rounded-3 overflow-hidden ${(chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X") && concordaSolucao !== 'NAO' ? 'bg-light' : ''}`}>
                                    <input type="file" id="fileInt" hidden multiple onChange={handleFileChange} accept="image/*,application/pdf" />
                                    <Button
                                        variant="light"
                                        className="bg-white border-0 px-3"
                                        onClick={() => document.getElementById('fileInt').click()}
                                        disabled={(chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X") && concordaSolucao !== 'NAO'}
                                    >
                                        <i className="bi bi-paperclip fs-5 text-secondary"></i>
                                    </Button>

                                    <Form.Control
                                        className="border-0 shadow-none py-2"
                                        placeholder={
                                            concordaSolucao === 'NAO'
                                                ? "Descreva o motivo da reabertura..."
                                                : (chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X")
                                                    ? "Este chamado foi finalizado!"
                                                    : "Escreva sua mensagem..."
                                        }
                                        value={novaMsg}
                                        onChange={(e) => setNovaMsg(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && enviarInteracao()}
                                        disabled={((chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X") && concordaSolucao !== 'NAO') || enviandoInt}
                                    />

                                    <Button
                                        style={{ backgroundColor: concordaSolucao === 'NAO' ? '#dc3545' : '#8b0000', borderColor: concordaSolucao === 'NAO' ? '#dc3545' : '#8b0000', color: '#ffffff' }}
                                        className="px-4 border-0 fw-bold"
                                        onClick={enviarInteracao}
                                        disabled={enviandoInt || ((chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X") && concordaSolucao !== 'NAO') || (!novaMsg.trim() && anexosNovos.length === 0)}
                                    >
                                        {enviandoInt ? <Spinner size="sm" /> : concordaSolucao === 'NAO' ? "Reabrir" : <i className="bi bi-send-fill"></i>}
                                    </Button>
                                </InputGroup>
                            </div>
                        </>
                    )}
                </div>
            </Modal>

            {/* MODAL APENAS CONSULTA DO CHAMADO */}
            <Modal
                show={showConsultaPai}
                onHide={handleFecharConsulta}
                size="lg"
                centered
                scrollable
                contentClassName="border-0 shadow-lg"
                style={{ zIndex: 1060 }}
            >
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white">
                        <i className="bi bi-eye-fill me-2"></i>[MODO CONSULTA] Chamado #{chamadoPaiDados?.id_chamado || chamadoPaiDados?.ID_CHAMADO} - {chamadoPaiDados?.assunto || chamadoPaiDados?.ASSUNTO}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: '#f8f9fa', maxHeight: '65vh', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
                    {loadingPai ? (
                        <div className="text-center p-4"><Spinner animation="border" style={{ color: '#8b0000' }} /></div>
                    ) : (
                        <>
                            <div className="d-flex justify-content-start mb-4">
                                <div className="shadow-sm p-3 bg-white border rounded-3" style={{ borderRadius: '0 15px 15px 15px', maxWidth: '85%' }}>
                                    <div className="border-bottom border-dark border-opacity-10 mb-2 pb-1">
                                        <div className="d-flex align-items-center gap-2">
                                            <AvatarUsuarioApi
                                                chapa={chamadoPaiDados?.chapa || chamadoPaiDados?.CHAPA || chamadoPaiDados?.chapa_solicitante || chamadoPaiDados?.CHAPA_SOLICITANTE || chamadoPaiDados?.chapa_usuario || chamadoPaiDados?.CHAPA_USUARIO || chamadoPaiDados?.usuario || chamadoPaiDados?.USUARIO}
                                                nome={chamadoPaiDados?.nome_usuario || chamadoPaiDados?.NOME_USUARIO}
                                                tamanho="26px"
                                                onSelectFoto={(dadosFoto) => setFotoSelecionada(dadosFoto)}
                                            />
                                            <span className="fw-bold small" style={{ color: '#8b0000' }}>
                                                {formatarNomePrimeiro(chamadoPaiDados?.nome_usuario || chamadoPaiDados?.NOME_USUARIO)}
                                            </span>

                                            <Badge style={{ backgroundColor: '#8b0000' }}>
                                                {chamadoPaiDados?.status_nome || chamadoPaiDados?.STATUS_NOME}
                                            </Badge>
                                        </div>
                                    </div>

                                    <div className="small mb-2 text-dark">
                                        <strong>Solicitante:</strong> {formatarNomePrimeiro(chamadoPaiDados?.nome_usuario || chamadoPaiDados?.NOME_USUARIO)} <br />
                                        <strong>Setor:</strong> {chamadoPaiDados?.nome_setor || chamadoPaiDados?.NOME_SETOR} <br />
                                        <strong>Loja:</strong> {String(chamadoPaiDados?.loja || chamadoPaiDados?.LOJA || '').padStart(2, '0')} <br />
                                        <strong>Categoria:</strong> {chamadoPaiDados?.categoria_nome || chamadoPaiDados?.CATEGORIA_NOME}
                                    </div>

                                    <div className="small text-dark mb-2" style={{ whiteSpace: 'pre-wrap' }}>
                                        {renderTextoComLinks(decodeBase64(chamadoPaiDados?.descricao || chamadoPaiDados?.DESCRICAO))}
                                    </div>

                                    {anexosPai.length > 0 && (
                                        <Row className="g-1 mt-2">
                                            {anexosPai.map((f, i) => {
                                                const nomeArquivo = f.NOME_ARQUIVO || f.nome || "";
                                                let base64 = (f.BASE64 || f.base64 || "").replace(/\r?\n|\r/g, "");
                                                return (
                                                    <Col xs={4} key={i}>
                                                        {renderCartaoAnexo(nomeArquivo, base64)}
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    )}

                                    <div className="text-end mt-1">
                                        <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                                            {formatarData(chamadoPaiDados?.data_abertura || chamadoPaiDados?.DATA_ABERTURA)}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            {interacoesPai.map((i, idx) => {
                                const usuarioInteracao = i.CHAPA || i.USUARIO || i.usuario || i.chapa;
                                const isMe = String(usuarioInteracao).trim() === String(chapa).trim();
                                const listAnexos = i.ANEXOS || i.anexos || [];
                                const statusNovoInt = i.status_novo !== undefined ? i.status_novo : i.STATUS_NOVO;
                                const notaConsulta = chamadoPaiDados?.nota_avaliacao || chamadoPaiDados?.NOTA_AVALIACAO;

                                return (
                                    <div
                                        key={idx}
                                        style={{
                                            display: 'flex',
                                            justifyContent: isMe ? 'flex-end' : 'flex-start',
                                            paddingLeft: isMe ? '40px' : '8px',
                                            paddingRight: isMe ? '8px' : '40px',
                                            marginBottom: '6px'
                                        }}
                                    >
                                        <div
                                            className="position-relative border shadow-sm"
                                            style={{
                                                borderRadius: isMe
                                                    ? '12px 12px 4px 12px'
                                                    : '12px 12px 12px 4px',
                                                backgroundColor: isMe ? '#f8d7da' : '#ffffff',
                                                maxWidth: '65%',
                                                padding: '8px 12px',
                                                display: 'inline-block'
                                            }}
                                        >
                                            <div className="d-flex align-items-center gap-1 mb-1" style={{ fontSize: '0.7rem' }}>
                                                <AvatarUsuarioApi
                                                    chapa={usuarioInteracao}
                                                    nome={isMe ? 'Você' : (i.NOME_USUARIO || i.nome_usuario)}
                                                    tamanho="22px"
                                                    onSelectFoto={(dadosFoto) => setFotoSelecionada(dadosFoto)}
                                                />
                                                <span className={`fw-bold ${isMe ? 'text-danger' : 'text-dark'}`}>
                                                    {isMe ? 'Você' : formatarNomePrimeiro(i.NOME_USUARIO || i.nome_usuario)}
                                                </span>

                                                <Badge bg="secondary" style={{ fontSize: '0.55rem' }}>
                                                    {i.STATUS_NOME || i.status_nome}
                                                </Badge>
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: '0.8rem',
                                                    color: '#111',
                                                    whiteSpace: 'pre-wrap',
                                                    lineHeight: '1.3'
                                                }}
                                            >
                                                {renderTextoComLinks(decodeBase64(i.MENSAGEM || i.mensagem))}
                                            </div>

                                            {listAnexos.length > 0 && (
                                                <Row className="g-1 mt-2">
                                                    {listAnexos.map((f, k) => {
                                                        const nomeArquivo = f.nome || f.NOME_ARQUIVO || "";
                                                        let base64 = (f.base64 || f.BASE64 || "").replace(/\r?\n|\r/g, "");
                                                        return (
                                                            <Col xs={4} key={k}>
                                                                {renderCartaoAnexo(nomeArquivo, base64)}
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                            )}

                                            {notaConsulta > 0 && statusNovoInt === 99 && (
                                                <div className="mt-2">
                                                    <Badge style={{ backgroundColor: '#8b0000' }}>
                                                        <b>Nota: </b>{notaConsulta}
                                                    </Badge>
                                                </div>
                                            )}

                                            <div className="text-end mt-1" style={{ opacity: 0.6 }}>
                                                <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                                                    {i.descricao || i.DESCRICAO} - {formatarData(i.DATA_INTEGRATION || i.data_interacao)}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" size="sm" className="fw-semibold" onClick={handleFecharConsulta}>Fechar Consulta</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL DE NOVO CHAMADO COM RECORRÊNCIA */}
            <ModalNovoChamado
                show={showNovo}
                onHide={() => {
                    setShowNovo(false);
                    setChamadoOrigemRecorrencia(null);
                }}
                loja={lojaSelecionada}
                chamadoOrigem={chamadoOrigemRecorrencia}
                onSuccess={() => {
                    setShowNovo(false);
                    setChamadoOrigemRecorrencia(null);
                    carregarChamados(1, false);
                }}
            />

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.info01}
                info02={fotoSelecionada?.info02}
            />

            {/* MODAL PDF */}
            <Modal
                show={!!pdfSelecionado}
                onHide={() => {
                    setPdfSelecionado(null);
                    setFullscreenPdf(false);
                }}
                size="lg"
            >
                <Modal.Header closeButton className="d-flex align-items-center justify-content-between bg-dark text-white">
                    <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                        <strong
                            className="text-white text-truncate"
                            style={{
                                fontSize: '0.9rem',
                                maxWidth: '100%',
                                display: 'block'
                            }}
                            title={pdfSelecionado?.nome}
                        >
                            {pdfSelecionado?.nome}
                        </strong>
                    </div>

                    <Button
                        variant="outline-light"
                        size="sm"
                        className="ms-2 flex-shrink-0 fw-bold"
                        onClick={() => setFullscreenPdf(true)}
                        style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}
                    >
                        <i className="bi bi-arrows-fullscreen me-1"></i>
                        <span className="d-none d-md-inline">Fullscreen</span>
                    </Button>
                </Modal.Header>

                <Modal.Body style={{ height: '75vh', padding: 0, display: 'flex', flexDirection: 'column' }}>
                    {urlParaVisualizar ? (
                        <>
                            <div className="d-flex justify-content-end p-2 bg-light border-bottom">
                                <Button
                                    style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                    size="sm"
                                    className="fw-bold"
                                    onClick={() => {
                                        const link = document.createElement('a');
                                        link.href = urlParaVisualizar;
                                        link.download = pdfSelecionado?.nome || "arquivo";
                                        link.click();
                                    }}
                                >
                                    <i className="bi bi-download me-1"></i> Baixar Arquivo
                                </Button>
                            </div>

                            <iframe
                                src={urlParaVisualizar}
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                                title="Visualizador"
                            />
                        </>
                    ) : (
                        <div className="text-center p-5">Carregando visualização...</div>
                    )}
                </Modal.Body>
            </Modal>

            <PdfFullscreen
                pdf={urlParaVisualizar}
                nome={pdfSelecionado?.nome}
                fullscreen={fullscreenPdf}
                setFullscreen={setFullscreenPdf}
            />

            <div
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'rgba(33, 37, 41, 0.85)',
                    color: '#fff',
                    padding: '6px 14px',
                    borderRadius: '50px',
                    fontSize: '0.75rem',
                    zIndex: 1020,
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(5px)',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }}
            >
                <Spinner
                    animation="border"
                    size="sm"
                    className="me-2 text-danger"
                    style={{ width: '12px', height: '12px', borderWidth: '2px' }}
                />
                <span>
                    Atualizando em {Math.floor(segundosParaAtualizar / 60)}:
                    {String(segundosParaAtualizar % 60).padStart(2, '0')}
                </span>
            </div>
            <Footer />
        </div>
    );
}

export default CentralChamados;